import { cachiosInstance } from "./cacheApi";

/**
 * ----------------------------
 *  Stats routes
 * ----------------------------
 */

export const getStats = (callback, force = false) => {
    cachiosInstance.get(`/stats`, { force })
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};